module.exports = __webpack_public_path__ + "img/edit-item-button.5cc04a38.svg";